import { Box, Button, Divider, Grid, IconButton, Typography, useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import { RegularSizeValue } from 'common-ts/dist/models/Cart';
import { useAppDispatch } from '../reduxhooks';
import OverlayComponentBaseContainerHorizontal from './OverlayComponentBaseContainerHorizontal';
import OverlayComponentBaseContainerWidth from './OverlayComponentBaseContainerWidth';
import EditIcon from '@material-ui/icons/Edit';
import OverlayComponentBaseTemplate from './OverlayComponentBaseTemplate';
import OverlayComponentCanvas, { DrawGuidelinesData } from './OverlayComponentCanvasFitAnimation';
import PageProductOverlayMeasureInstructions from './OverlayViewGenerateMeasureMethod3Favorite1ModifySizePopup';
import { ClothingMeasurementAdjustmentLevel, ClothingMeasurementDetailList, 
  ClothingMeasurements, ClothingMeasurementsKey, ClothingType, 
  BodyMeasurements, FitType, CalculateClothingMeasurementsFromBodyMeasurements, RoundClothingMeasurementsToHalfPoint, ClothingMeasurementAdjustmentDisplayRange, GetKey2CategoryClothingSizeMeasurementValues, BodyMeasurementsKey, DefaultFollowingMeasurementsForClothingTypeAndFitType,
  ClothBodyToDisplayedClothMeasForClothingTypeAndFitType, 
  CalculateClothBodyMeasurementsFromBodyMeasurements,
  GetChangedClothingMeasurementsFromBodyMeasurementsUpdate} from 'common-ts/dist/models/UserMeasurements';
import { openOverlay } from '../redux/UIOverlayMeasureInstructionsRedux';
import { retryGetRequest } from '../redux/CartRedux';
import { AxiosRequestConfig } from 'axios';
import hash from 'object-hash';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import RestoreIcon from '@mui/icons-material/RestartAlt';
import { SizeWheelComponent, getClothingMeasurementsRuler, getClothingMeasurementsSubtext } from './OverlayViewGenerateMeasureMethod3Favorite1ModifySize';
import { UkuranBadanCardMini } from './PageProductDetailSizeOptions';
import { socket } from '../socket';
import { OfflineActiveScreen } from '../redux/UIOverlayOfflineRedux';

const PersonalSizeClothingMeasurementOrdering: ClothingMeasurementsKey[] = 
[
  ClothingMeasurementsKey.lingkarLeherBaju,
  ClothingMeasurementsKey.lebarDadaBaju, 
  ClothingMeasurementsKey.lebarPerutBaju, 
  ClothingMeasurementsKey.panjangBaju, 
  ClothingMeasurementsKey.lebarBahuBaju, 
  ClothingMeasurementsKey.panjangLenganPanjang, 
  ClothingMeasurementsKey.lebarLenganAtasBaju,
  ClothingMeasurementsKey.panjangLenganPendek, 
  ClothingMeasurementsKey.lebarLenganBaju,
];

interface stylesProps {
  isMinimized: boolean 
}

const useStyles = (({ isMinimized }: stylesProps) => makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: '300px',
      [theme.breakpoints.only('xs')]: {
        width: '240px',
      }
    },
    gridContainer: {
      width: isMinimized ? '90%' : '100%',
      [theme.breakpoints.up('md')]: {
        paddingTop: isMinimized ? '0px' : '0px',
      },
    },
    form: {
      height: 'auto',
      padding: '0px 24px 0px 24px',
      [theme.breakpoints.only('xs')]: {
        padding: '0px 0px 0px 0px',
      }
    },
    formRow: {
      paddingBottom: '30px',
    },
    subFormTitle: {
    },
    toggleSignUpSignInContainer: {
      paddingTop: '30px',
      paddingBottom: '30px',
      // paddingLeft: '10px',
      paddingRight: '10px',
    },
    buttonContainer: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "baseline",
      justifyContent: isMinimized ? 'space-between' : 'flex-end',
      width: '100%',
      paddingBottom: '12px',
      [theme.breakpoints.only('xs')]: {
        paddingBottom: '6px',
      }
    },
    canvasContainer: {
      width: '100%',
      height: '100%',
      [theme.breakpoints.only('xs')]: {
        height: '75vw',
      },
      position: 'relative',
    },
    measurementValueContainer: {
      width: '100%',
      height: isMinimized ? '35px' : '40px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: "baseline",
    },
    measurementNameText: {
      fontSize: isMinimized ? '10.5px' : '12px',
      fontWeight: isMinimized ? 400 : 300,
  
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',

      cursor: "pointer",
      '-webkit-tap-highlight-color': 'transparent',
    },
    measurementNameTextIIcon: {
      fontSize: isMinimized ? '9.5px' : '11px',
      marginLeft: "3px",
    },
    measurementValueTextContainer: {
      width: "50%",
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    measurementValueText: {
      fontFamily: 'Open Sans, sans-serif',
      fontSize: isMinimized ? '10.5px' : '12px',
      fontWeight: 500,
      marginBottom: '0px',
    },
    measurementValueTextSub: {
      fontFamily: 'Open Sans, sans-serif',
      fontSize: isMinimized ? '8px' : '10px',
      fontWeight: isMinimized ? 400 : 300,
      letterSpacing: '0.7px',
      color: '#3e3e3e',
      textWrap: 'nowrap',
      width: '200%'
    },
    measurementChangeValueButton: {
      width: isMinimized ? "20%" : '25%',
      minWidth: "4px",
      padding: "0px",
      '& .MuiButton-label': {
        fontSize: isMinimized ? '15.5px' : '18px',
        fontWeight: 400,
      }
    },
    ukuranCustomAvailText: {
      fontWeight: 500,
      fontSize: isMinimized ? '8.5px' : '11px',
      letterSpacing: '0.05px',
      marginTop: '7px',
      marginBottom: isMinimized ? '-6px' : '-20px',
    }
  }),
));

interface PersonalFitMeasurementsDetailPanelProps {
  allowEditing: boolean
  currentClothingMeas: ClothingMeasurements
  currentClothingMeasSubtextDict: {[key:string]: string}
  currentClothingMeasUpdatedDict?: ClothingMeasurements
  currentlyFetchingAvailability: boolean
  clothMeasActionsDict?: {
    [key: string]: {
      clothMeasInfoFunction: () => void
      minusDetail: {
        onClickFunction: () => void
        isEnabled: boolean
        needsMod: boolean
      }
      plusDetail: {
        onClickFunction: () => void
        isEnabled: boolean
        needsMod: boolean
      }
      enableFollowingToggle?: () => void
      isFollowing?: boolean
    }
  }
  isMinimized?: boolean
  isSizeWheel?: boolean
  isMdOrUp?: boolean
  sizeWheelDict?: {[key:string]: {
    sizeNamesArray: string[] // ['XXS', 'XS', 'S', ... ]
    sizeValuesArray: number[] // [42, 46, 50, ... ]
    currentValue: number
    clothMeasName: string
  }}
  reductionMode?: boolean
}

function PersonalFitMeasurementDetailPanel({
  allowEditing, currentClothingMeas, currentClothingMeasUpdatedDict, currentClothingMeasSubtextDict,
  currentlyFetchingAvailability, clothMeasActionsDict, isMinimized=false, isSizeWheel=false, isMdOrUp=false, reductionMode=false,
  sizeWheelDict={'ax': {sizeNamesArray: [], sizeValuesArray: [], currentValue: 10, clothMeasName:'sdfa'}}}: PersonalFitMeasurementsDetailPanelProps) {
  const classes = useStyles({isMinimized: isMinimized})();

  const clothingMeasurementsDisplayed = Object.values(ClothBodyToDisplayedClothMeasForClothingTypeAndFitType["Body"]);

  return (
    <Grid container className={classes.gridContainer} 
    direction="row" justifyContent="flex-start">
    {
      PersonalSizeClothingMeasurementOrdering.map((itemKey) => {
        if (!clothingMeasurementsDisplayed.includes(itemKey as ClothingMeasurementsKey)) {
          return null;
        }
        if (currentClothingMeas[itemKey as ClothingMeasurementsKey] === undefined) {
          return null;
        }
        if (ClothingMeasurementDetailList[itemKey as ClothingMeasurementsKey] === undefined
          || ClothingMeasurementAdjustmentLevel[itemKey as ClothingMeasurementsKey] === undefined
          || ClothingMeasurementAdjustmentLevel[itemKey as ClothingMeasurementsKey] === "unavailable") {
          return null;
        }

        const measurementName = ClothingMeasurementDetailList[itemKey as ClothingMeasurementsKey].clothingMeasurementName;
        const measurementValue = currentClothingMeas[itemKey as keyof ClothingMeasurements] as number;

        const isAdvancedFeature = clothMeasActionsDict?.[itemKey].enableFollowingToggle ? true : false;

        return (
          <Grid item xs={12} >
            {
              itemKey === ClothingMeasurementsKey.panjangLenganPendek ?
              <Grid container style={{width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: '14px 0px 5px'}}>
                <Box style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                  <Typography style={{fontSize: '9.7px', letterSpacing: '0.5px', marginBottom: '3px', color: '#232323'}}>
                    PENGATURAN DETAIL
                  </Typography>
                </Box>
                <Divider/>
              </Grid>:
              null
            }
            <Grid container className={classes.measurementValueContainer}>
              <Grid item xs={7}>
                <Typography className={classes.measurementNameText}
                onClick={() => {
                    if (isAdvancedFeature) {
                      (clothMeasActionsDict?.[itemKey].enableFollowingToggle as any)();
                    } else {
                      (clothMeasActionsDict?.[itemKey].clothMeasInfoFunction as any)();
                    }
                  }}>
                  {itemKey === ClothingMeasurementsKey.lebarLenganBaju ? "Lebar Lengan Pendek " : measurementName + " "}
                  {
                    !isAdvancedFeature ? 
                    <span className={classes.measurementNameTextIIcon}>&#x24D8;</span>:
                    clothMeasActionsDict?.[itemKey].isFollowing ?
                    <span className={classes.measurementNameTextIIcon}
                    style={{padding: '4px 9px 2px', backgroundColor: 'rgb(255, 255, 255)',
                      border: '1px solid rgb(100,100,100)',
                      borderRadius: '10px',
                      fontSize: '8px',
                      letterSpacing: '0.6px',
                    }}
                    onClick={() => {
                      if (isAdvancedFeature) {
                        (clothMeasActionsDict?.[itemKey].enableFollowingToggle as any)();
                      }
                    }}>
                      <EditIcon style={{height: '8px', width: '8px'}}/>
                      {" ATUR"}
                    </span>:
                    <span className={classes.measurementNameTextIIcon}
                    style={{padding: '4px 9px 2px', backgroundColor: '#dd0b0b', color: '#ffffff',
                      borderRadius: '10px',
                      fontSize: '8px',
                      letterSpacing: '0.6px',
                    }}
                    onClick={() => {
                      if (isAdvancedFeature) {
                        (clothMeasActionsDict?.[itemKey].enableFollowingToggle as any)();
                      }
                    }}>
                      {"HAPUS"}
                    </span>
                  }
                  {
                    currentClothingMeasUpdatedDict?.[itemKey] ?
                    <span style={{fontSize: '5px', fontWeight: 500, letterSpacing: '0.5px',
                      color: '#fff', backgroundColor: 'rgb(0, 100, 0)', padding: '3px 5px 2px', marginLeft: '3px', borderRadius: '10px' }}>UPDATED</span>:
                    undefined
                  }
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Box className={classes.buttonContainer}>
                  <Button onClick={clothMeasActionsDict?.[itemKey].minusDetail.onClickFunction}
                  disabled={!allowEditing || currentlyFetchingAvailability || !clothMeasActionsDict?.[itemKey].minusDetail.isEnabled ||
                    (isAdvancedFeature && clothMeasActionsDict?.[itemKey].minusDetail.needsMod)}
                  style={{
                    color: 
                    allowEditing && clothMeasActionsDict?.[itemKey].minusDetail.isEnabled && !(isAdvancedFeature && clothMeasActionsDict?.[itemKey].minusDetail.needsMod)? 
                    '#232323': 
                    '#efefef',
                    position: 'relative'
                  }}
                  className={classes.measurementChangeValueButton}>
                    -
                    {clothMeasActionsDict?.[itemKey].minusDetail.needsMod && !isAdvancedFeature ? 
                      <img src={'https://studiosclo.uk/general/icon-uk-favorit-mod.png'}
                      style={{
                        width: '0.5rem',
                        position: 'absolute',
                        left: '1.2rem',
                        top: '0.1rem',
                      }}
                      alt={'uk-favorit-mod-min'}
                      /> : null}
                  </Button>
                  {
                    isAdvancedFeature && clothMeasActionsDict?.[itemKey].isFollowing ?
                    <Box className={classes.measurementValueTextContainer} style={{
                      scale: reductionMode ? '1.2' : undefined,
                      width: reductionMode ? '36%' : undefined,
                    }}>
                      <SizeWheelComponent  
                        sizeNamesArray={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.sizeNamesArray ?? []} 
                        sizeValuesArray={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.sizeValuesArray ?? []} 
                        currentValue={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.currentValue ?? 10} 
                        clothMeasName={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.clothMeasName ?? 'ax'} />
                      <Typography className={classes.measurementValueTextSub} style={{marginTop: '6.2px', color: '#212121', fontSize: reductionMode ? '6px' : '8.8px', letterSpacing: '0.04px'}}>
                        Disesuaikan Otomatis
                      </Typography>
                    </Box>:
                    isAdvancedFeature && !clothMeasActionsDict?.[itemKey].isFollowing ?
                    <Box className={classes.measurementValueTextContainer}>
                      <Typography className={classes.measurementValueText}>
                        {measurementValue} cm
                      </Typography>
                      <Typography className={classes.measurementValueTextSub}>
                        {currentClothingMeasSubtextDict?.[itemKey as ClothingMeasurementsKey]}
                      </Typography>
                    </Box>:
                    isSizeWheel ? 
                    <Box className={classes.measurementValueTextContainer} style={{
                      scale: reductionMode ? '1.2' : undefined,
                      width: reductionMode ? '36%' : undefined,
                    }}>
                      <SizeWheelComponent  
                        sizeNamesArray={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.sizeNamesArray ?? []} 
                        sizeValuesArray={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.sizeValuesArray ?? []} 
                        currentValue={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.currentValue ?? 10} 
                        clothMeasName={sizeWheelDict?.[itemKey as ClothingMeasurementsKey]?.clothMeasName ?? 'ax'} />
                      <Typography className={classes.measurementValueTextSub} style={{marginTop: '6.2px', color: '#212121', fontSize: '8.8px', letterSpacing: '0.04px', visibility: reductionMode ? 'hidden' : undefined}}>
                        {itemKey === "lingkarLeherBaju" ? 'Uk ' + currentClothingMeasSubtextDict?.[itemKey as ClothingMeasurementsKey] : `Hasil Baju ${measurementValue} cm`}
                      </Typography>
                    </Box>:
                    <Box className={classes.measurementValueTextContainer}>
                      <Typography className={classes.measurementValueText}>
                        {measurementValue} cm
                      </Typography>
                      <Typography className={classes.measurementValueTextSub}>
                        {currentClothingMeasSubtextDict?.[itemKey as ClothingMeasurementsKey]}
                      </Typography>
                    </Box>
                  }
                  <Button onClick={clothMeasActionsDict?.[itemKey].plusDetail.onClickFunction}
                  disabled={!allowEditing || currentlyFetchingAvailability || !clothMeasActionsDict?.[itemKey].plusDetail.isEnabled ||
                    (isAdvancedFeature && clothMeasActionsDict?.[itemKey].plusDetail.needsMod)
                  }
                  style={{
                    color: 
                    allowEditing && clothMeasActionsDict?.[itemKey].plusDetail.isEnabled && !(isAdvancedFeature && clothMeasActionsDict?.[itemKey].plusDetail.needsMod) ? 
                    '#232323' : 
                    '#efefef',
                    position: 'relative'
                  }}
                  className={classes.measurementChangeValueButton}>
                    +
                    {clothMeasActionsDict?.[itemKey].plusDetail.needsMod && !isAdvancedFeature ? 
                      <img src={'https://studiosclo.uk/general/icon-uk-favorit-mod.png'}
                      style={{
                        width: '0.5rem',
                        position: 'absolute',
                        left: '1.2rem',
                        top: '0.1rem',
                      }}
                      alt={'uk-favorit-mod-plus'}
                      /> : null}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        )
      })
    }
    {
      (allowEditing && !isMinimized && !isMdOrUp) ? 
        <Grid item xs={12} style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          marginTop: '26px'
        }}>
          <img src={'https://studiosclo.uk/general/uk-favorit-keterangan.png'}
          alt={'uk-favorit-keterangan'}
          style={{ width: '90%' }}/> 
        </Grid>:
        null
    }
  </Grid>
  );
}

interface Props {
  startingClothingBodyMeasurements: BodyMeasurements // B-complete and CB-optional
  startingClothingBodyMeasurementsCBComplete: BodyMeasurements // CB-complete
  startingClothingMeasurements: ClothingMeasurements // CB-complete
  startingRawClothingMeasurements: ClothingMeasurements // CB-complete
  handleSubmit: (value: BodyMeasurements, valueClothing: ClothingMeasurements, lastUpdatedMeasurementsList: BodyMeasurements) => void
  isMinimized?: boolean
  isStoreScreen?: string
  forceClothingMeasurementsValue?: BodyMeasurements
  forceGuidelinesData?: DrawGuidelinesData
  firstName?: string
}

export default function RegularModifySize({startingClothingBodyMeasurements, startingClothingBodyMeasurementsCBComplete, startingClothingMeasurements, startingRawClothingMeasurements, handleSubmit, isMinimized=false, isStoreScreen=undefined, forceClothingMeasurementsValue=undefined, forceGuidelinesData, firstName=undefined}: Props) {
  const dispatch = useAppDispatch();
  const classes = useStyles({isMinimized: isMinimized})();
  const theme = useTheme();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));

  const bodyKey2 = "Body-RegularFit";

  const [currentClothingMeas, setCurrentClothingMeas] = React.useState<ClothingMeasurements>(startingClothingMeasurements);
  const [currentRawClothingMeas, setCurrentRawClothingMeas] = React.useState<ClothingMeasurements>(startingRawClothingMeasurements);
  const [currentClothingBodyMeas, setCurrentClothingBodyMeas] = React.useState<BodyMeasurements>(startingClothingBodyMeasurementsCBComplete); // CB-complete. Settings are contained in the following list.
  const [followingClothingBodyMeas, setFollowingClothingBodyMeas] = React.useState<BodyMeasurementsKey[]>(DefaultFollowingMeasurementsForClothingTypeAndFitType[bodyKey2].filter((valBodyMeas) => !startingClothingBodyMeasurements?.[valBodyMeas]));

  const [drawGuidelinesData, setDrawGuidelinesData] = React.useState<DrawGuidelinesData | undefined>(undefined);

  const [currentlyFetchingAvail, setCurrentlyFetchingAvail] = React.useState<boolean>(false);
  const [lastFetchStatus, setLastFetchStatus] = React.useState<string>('TOFETCH');
  const [nextMeasDict, setNextMeasDict] = React.useState<any>({});

  // Infer changes
  const changedClothingBodyMeasCur: BodyMeasurements = {};
  // CHECK SPECIFIC ON AFTER
  for (let bodyMeasKey of Object.keys(startingClothingBodyMeasurementsCBComplete)) {
    // IF THE VALUE IS DIFFERENT, WE ADD TO CHANGED DICT
    if (currentClothingBodyMeas[bodyMeasKey as keyof BodyMeasurements] !== 
      startingClothingBodyMeasurementsCBComplete[bodyMeasKey as keyof BodyMeasurements]) {
      changedClothingBodyMeasCur[bodyMeasKey as keyof BodyMeasurements] = currentClothingBodyMeas[bodyMeasKey as keyof BodyMeasurements];
    }
  }

  // Change Feature
  const [changesDetected, setChangesDetected] = React.useState(false);

  const [advancedFeatureCallback, setAdvancedFeatureCallback] = React.useState<(() => void) | null>(null);

  const handleReset = () => {
    setCurrentClothingMeas(startingClothingMeasurements);
    setCurrentRawClothingMeas(startingRawClothingMeasurements);
    setCurrentClothingBodyMeas(startingClothingBodyMeasurementsCBComplete);
    setFollowingClothingBodyMeas(DefaultFollowingMeasurementsForClothingTypeAndFitType[bodyKey2].filter((valBodyMeas) => !startingClothingBodyMeasurements?.[valBodyMeas]));
    setChangesDetected(false);
    setDrawGuidelinesData(undefined);

    updateClothingMeasurement(startingClothingBodyMeasurementsCBComplete, DefaultFollowingMeasurementsForClothingTypeAndFitType[bodyKey2].filter((valBodyMeas) => !startingClothingBodyMeasurements?.[valBodyMeas]), '', undefined);
  };

  useEffect(() => {
    if (forceClothingMeasurementsValue) {
      let measurementsForItem: BodyMeasurements = forceClothingMeasurementsValue;
      let clothMeasurementsForItem: ClothingMeasurements = CalculateClothingMeasurementsFromBodyMeasurements(ClothingType.Body, FitType.RegularFit, 
        measurementsForItem, RegularSizeValue.L);
      setCurrentRawClothingMeas(clothMeasurementsForItem);
      setCurrentClothingMeas(RoundClothingMeasurementsToHalfPoint(clothMeasurementsForItem));
      setCurrentClothingBodyMeas(measurementsForItem);
    }
  }, [forceClothingMeasurementsValue]);

  useEffect(() => {
    const hasChanges = 
      JSON.stringify(currentClothingMeas) !== JSON.stringify(startingClothingMeasurements) ||
      JSON.stringify(currentClothingBodyMeas) !== JSON.stringify(startingClothingBodyMeasurementsCBComplete);
    setChangesDetected(hasChanges);
  }, [currentClothingMeas, currentClothingBodyMeas]);


  function updateClothingMeasurement(
    newClothingBodyMeasurements: BodyMeasurements, 
    lastFollowingList: BodyMeasurementsKey[],
    originalHash: string,
    completeAdjustment: any,
  ) {
    if (originalHash === 'reset-body') {
      getCurrentProposedSizeAvailability(newClothingBodyMeasurements, lastFollowingList);
      return;
    }
    // If there's no original hash, we assume this is a "forced" update and 
    if (!originalHash) {
      setNextMeasDict({}); // Since the original is very "far" from the current measurement, we disable the measurements first.
      getCurrentProposedSizeAvailability(newClothingBodyMeasurements, lastFollowingList);
      return;
    }

    if (hash(currentClothingBodyMeas) === originalHash) {
      getCurrentProposedSizeAvailability(newClothingBodyMeasurements, lastFollowingList);
    } else {
      // NOTE 
      // Effectively removes the "switching" bug, since the new adjustment is combined with the previous (fetching)
      // adjustment. If there is slow / no connectivity, however, this would only work "once" per variable until the 
      // request returns, since the plus / minus adjustments are NOT updated until the response arrives from the server.
      // There is an inherent tradeoff: If each step is "provided" by the server, we reach better continuity / consistency,
      // but if the internet is slow there will be some "lag". If we do local, there is risk, but much faster. 
      getCurrentProposedSizeAvailability({
        ...currentClothingBodyMeas,
        ...completeAdjustment
      }, lastFollowingList);
    }
  }

  useEffect(() => {
    getCurrentProposedSizeAvailability(startingClothingBodyMeasurementsCBComplete, DefaultFollowingMeasurementsForClothingTypeAndFitType[bodyKey2].filter((valBodyMeas) => !startingClothingBodyMeasurements?.[valBodyMeas]));
  }, []);

  async function getCurrentProposedSizeAvailability(proposedClothBodyMeasurements: BodyMeasurements, lastFollowingList: BodyMeasurementsKey[]) {
    if (proposedClothBodyMeasurements) {
      // setCurrentlyFetchingAvail(true);

      // console.log(lastFollowingList);
  
      let measurementsForItem: BodyMeasurements = proposedClothBodyMeasurements; // Already CB-complete
      let clothMeasurementsForItem: ClothingMeasurements = CalculateClothingMeasurementsFromBodyMeasurements(ClothingType.Body, FitType.RegularFit, 
        measurementsForItem, RegularSizeValue.L);
      setCurrentRawClothingMeas(clothMeasurementsForItem);
      setCurrentClothingMeas(RoundClothingMeasurementsToHalfPoint(clothMeasurementsForItem));
      setCurrentClothingBodyMeas(measurementsForItem);

      if (isStoreScreen) {
        socket.timeout(5000).emit('chat message', {
          currentStore: 'STORE1',
          currentScreen: OfflineActiveScreen.SizeSelect,
          justUpdateSize: true,
          currentBodyMeasurements: measurementsForItem,
        });
      }

      // We use the CB-optional, B-complete measurement
      const measPolicy: any = {};
      for (let measKey of Object.keys(measurementsForItem)) {
        measPolicy[measKey] = "EXACT";
      }

      let config: AxiosRequestConfig = { }

      config = {
        method: 'post',
        url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/availability/meas-serviceable',
        data: JSON.stringify(
          {
            isBody: true,
            measurements: measurementsForItem,
            measurementsPolicy: measPolicy
          })
      };

      retryGetRequest(config, 8).then((response) => {
        setCurrentlyFetchingAvail(false);
        if (response?.data?.provisionStatus) {
          setLastFetchStatus(response?.data?.provisionStatus);
        }
        if (response?.data?.additionalRequestResultData?.changeMeasurementsDict
          && response?.data?.additionalRequestResultData?.measurementsResult) {
          const nextMeasDict: any = {};

          const changeMeasurementsDict: any = response.data.
            additionalRequestResultData.changeMeasurementsDict; // This is in BodyMeas space
          const originalClothBodyMeas: any = response.data.
            additionalRequestResultData.measurements;
          const resultClothBodyMeas: any = response.data.
            additionalRequestResultData.measurementsResult;
          const hashResultClothBodyMeas: string = hash(resultClothBodyMeas);

          if (hash(resultClothBodyMeas) !== hash(originalClothBodyMeas)) {
            updateClothingMeasurement(resultClothBodyMeas, lastFollowingList, '', undefined);
            setLastFetchStatus("ENOUGH");
            return;
          }

          for (let bodyMeasName of Object.keys(changeMeasurementsDict)) {
            const bodyMainAdj = Object.keys(changeMeasurementsDict[bodyMeasName].mainAdjustment)[0];
            const bodyMainAdjValueOriginal = resultClothBodyMeas[bodyMainAdj];
            const bodyMainAdjValue = changeMeasurementsDict[bodyMeasName].mainAdjustment[bodyMainAdj];
            const isServiceable = changeMeasurementsDict[bodyMeasName].isServiceable;
            const modAdjustment = changeMeasurementsDict[bodyMeasName].modAdjustment;

            const displayClothChangeKey = ClothBodyToDisplayedClothMeasForClothingTypeAndFitType["Body"]?.[bodyMainAdj as BodyMeasurementsKey];

            if (displayClothChangeKey === undefined) {
              continue;
            }

            const changeIsPlus = bodyMainAdjValue > bodyMainAdjValueOriginal;

            const completeAdjustment = {
              [bodyMainAdj]: bodyMainAdjValue,
            }

            const newClothBodyMeas = {
              ...resultClothBodyMeas,
              [bodyMainAdj]: bodyMainAdjValue
            }
            let filteredModAdjustment = modAdjustment;
            // let filteredModAdjustment = undefined;
            // if (modAdjustment) {
            //   let draftModAdjustment: any = {

            //   }
            //   for (let measKey of Object.keys(modAdjustment)) {
            //     if (lastFollowingList.includes(measKey as BodyMeasurementsKey)) {
            //       continue;
            //     }
            //     draftModAdjustment[measKey] = modAdjustment[measKey];
            //   }
            //   if (Object.keys(draftModAdjustment)?.length) {
            //     filteredModAdjustment = draftModAdjustment;
            //   }
            // }
            if (filteredModAdjustment) {
              for (let measKey of Object.keys(filteredModAdjustment)) {
                newClothBodyMeas[measKey] = filteredModAdjustment[measKey]
                completeAdjustment[measKey] = filteredModAdjustment[measKey]
              }
            }
            
            // We remove the current changed main adjustment from the "following" list
            const newFollowingList = lastFollowingList.filter((value) => value.toString() !== bodyMainAdj);

            // Enforce the variables in the following list
            const newClothBodyMeasAfterFollowing = CalculateClothBodyMeasurementsFromBodyMeasurements(ClothingType.Body, FitType.RegularFit, 
              newClothBodyMeas, RegularSizeValue.L, newFollowingList);

            // We need is serviceable, if there is a mod adjustable needed, and the next clothing measurements
            nextMeasDict[displayClothChangeKey + (changeIsPlus ? "Plus" : "Minus")] = {
              isServiceable: isServiceable,
              modAdjustment: filteredModAdjustment,
              needsMod: filteredModAdjustment ? true : false,
              nextClothingBodyMeas: newClothBodyMeasAfterFollowing,
              nextFollowingClothingBodyMeas: newFollowingList,
              completeAdjustment: completeAdjustment,
              hashOriginalClothingBodyMeas: hashResultClothBodyMeas,
            };
          }

          setNextMeasDict(nextMeasDict);
        }
      });
    }
  }

  const key2ClothSizeValues = GetKey2CategoryClothingSizeMeasurementValues(ClothingType.Body, FitType.RegularFit, false);
  const subtextDictBody = getClothingMeasurementsSubtext(ClothingType.Body, key2ClothSizeValues, currentClothingMeas);
  const sizeRulerDictBody = getClothingMeasurementsRuler(ClothingType.Body, key2ClothSizeValues, currentRawClothingMeas);

  const inputClothMeasActionsDict: {[key:string]: {
    clothMeasInfoFunction: () => void
    minusDetail: {
      onClickFunction: () => void
      isEnabled: boolean
      needsMod: boolean
    }
    plusDetail: {
      onClickFunction: () => void
      isEnabled: boolean
      needsMod: boolean
    }
  }} = {};
  const clothingMeasurementsDisplayed = Object.values(ClothBodyToDisplayedClothMeasForClothingTypeAndFitType["Body"]);
  for (let i = 0; i < PersonalSizeClothingMeasurementOrdering.length; i++) {
    const itemKey = PersonalSizeClothingMeasurementOrdering[i];
    if (!clothingMeasurementsDisplayed.includes(itemKey as ClothingMeasurementsKey)) {
      continue;
    }
    if (currentClothingMeas[itemKey as ClothingMeasurementsKey] === undefined) {
      continue;
    }
    if (ClothingMeasurementDetailList[itemKey as ClothingMeasurementsKey] === undefined
      || ClothingMeasurementAdjustmentLevel[itemKey as ClothingMeasurementsKey] === undefined
      || ClothingMeasurementAdjustmentLevel[itemKey as ClothingMeasurementsKey] === "unavailable") {
      continue;
    }

    let chosenBodyMeasKey: BodyMeasurementsKey | undefined = undefined;
    for (let bodyMeasKey of Object.keys(ClothBodyToDisplayedClothMeasForClothingTypeAndFitType["Body"])) {
      if (ClothBodyToDisplayedClothMeasForClothingTypeAndFitType?.["Body"]?.[bodyMeasKey as BodyMeasurementsKey]
         === itemKey) {
        chosenBodyMeasKey = bodyMeasKey as BodyMeasurementsKey;
      }
    }
    if (chosenBodyMeasKey === undefined) {
      return null;
    }

    const measurementName = ClothingMeasurementDetailList[itemKey as ClothingMeasurementsKey].clothingMeasurementName;

    const itemObject: {
      clothMeasInfoFunction: () => void
      minusDetail: {
        onClickFunction: () => void
        isEnabled: boolean
        needsMod: boolean
      }
      plusDetail: {
        onClickFunction: () => void
        isEnabled: boolean
        needsMod: boolean
      }
      enableFollowingToggle?: () => void
      isFollowing?: boolean
    } = {
      isFollowing: chosenBodyMeasKey === BodyMeasurementsKey.panjangLenganPendek || chosenBodyMeasKey === BodyMeasurementsKey.lebarLenganPendek ? followingClothingBodyMeas.includes(chosenBodyMeasKey as BodyMeasurementsKey) : undefined,
      enableFollowingToggle: chosenBodyMeasKey === BodyMeasurementsKey.panjangLenganPendek || chosenBodyMeasKey === BodyMeasurementsKey.lebarLenganPendek ? () => {
        if (followingClothingBodyMeas.includes(chosenBodyMeasKey as BodyMeasurementsKey)) {
          setAdvancedFeatureCallback(() => {
            return (() => {
              const newFollowingList = followingClothingBodyMeas.filter((followListObj) => followListObj !== chosenBodyMeasKey);
              setFollowingClothingBodyMeas(newFollowingList);
    
              // Enforce the variables in the following list
              const newClothBodyMeasAfterFollowing = CalculateClothBodyMeasurementsFromBodyMeasurements(ClothingType.Body, FitType.RegularFit, 
                currentClothingBodyMeas, RegularSizeValue.L, newFollowingList);
    
              updateClothingMeasurement(newClothBodyMeasAfterFollowing, newFollowingList, 'reset-body', undefined);
            }); // We return a function
          });
          
          dispatch(openOverlay(itemKey as ClothingMeasurementsKey));  
        } else {
          setAdvancedFeatureCallback(null);

          const newFollowingList = [...followingClothingBodyMeas, chosenBodyMeasKey as BodyMeasurementsKey];
          setFollowingClothingBodyMeas(newFollowingList);

          // Enforce the variables in the following list
          const newClothBodyMeasAfterFollowing = CalculateClothBodyMeasurementsFromBodyMeasurements(ClothingType.Body, FitType.RegularFit, 
            currentClothingBodyMeas, RegularSizeValue.L, newFollowingList);

          updateClothingMeasurement(newClothBodyMeasAfterFollowing, newFollowingList, 'reset-body', undefined);
        }
      }: undefined,
      clothMeasInfoFunction: () => {
        dispatch(openOverlay(itemKey as ClothingMeasurementsKey));  
        setAdvancedFeatureCallback(null);
      },
      minusDetail: {
        onClickFunction: () => {
          if (nextMeasDict?.[itemKey + "Minus"]?.isServiceable) {
            setFollowingClothingBodyMeas(nextMeasDict[itemKey + "Minus"].nextFollowingClothingBodyMeas);
            updateClothingMeasurement(nextMeasDict[itemKey + "Minus"].nextClothingBodyMeas, nextMeasDict[itemKey + "Minus"].nextFollowingClothingBodyMeas, nextMeasDict[itemKey + "Minus"].hashOriginalClothingBodyMeas, nextMeasDict[itemKey + "Minus"].completeAdjustment);

            // UPDATE GUIDELINES DATA
            const newDrawGuidelinesData: DrawGuidelinesData = {
              lastChangedMeasurement: itemKey,
              lastChangedMeasurementName: measurementName,
              guidelineDisplayRange: ClothingMeasurementAdjustmentDisplayRange[itemKey as ClothingMeasurementsKey],
              sizeMeasurementValues: key2ClothSizeValues.regularSizeClothMeasValues,
              sizeMeasurementNames: key2ClothSizeValues.regularSizeNames,
            }
            setDrawGuidelinesData(newDrawGuidelinesData);

            if (isStoreScreen) {
              socket.timeout(5000).emit('chat message', {
                currentStore: 'STORE1',
                currentScreen: OfflineActiveScreen.SizeSelect,
                justUpdateGuidelines: true,
                guidelinesData: newDrawGuidelinesData,
              });
            }
          }
        },
        isEnabled: nextMeasDict?.[itemKey + "Minus"]?.isServiceable && !followingClothingBodyMeas.includes(chosenBodyMeasKey),
        needsMod: nextMeasDict?.[itemKey + "Minus"]?.needsMod,
      },
      plusDetail: {
        onClickFunction: () => {
          if (nextMeasDict?.[itemKey + "Plus"]?.isServiceable) {
            setFollowingClothingBodyMeas(nextMeasDict[itemKey + "Plus"].nextFollowingClothingBodyMeas);
            updateClothingMeasurement(nextMeasDict[itemKey + "Plus"].nextClothingBodyMeas, nextMeasDict[itemKey + "Plus"].nextFollowingClothingBodyMeas, nextMeasDict[itemKey + "Plus"].hashOriginalClothingBodyMeas, nextMeasDict[itemKey + "Plus"].completeAdjustment);

            // UPDATE GUIDELINES DATA
            const newDrawGuidelinesData: DrawGuidelinesData = {
              lastChangedMeasurement: itemKey,
              lastChangedMeasurementName: measurementName,
              guidelineDisplayRange: ClothingMeasurementAdjustmentDisplayRange[itemKey as ClothingMeasurementsKey],
              sizeMeasurementValues: key2ClothSizeValues.regularSizeClothMeasValues,
              sizeMeasurementNames: key2ClothSizeValues.regularSizeNames,
            }
            setDrawGuidelinesData(newDrawGuidelinesData);

            if (isStoreScreen) {
              socket.timeout(5000).emit('chat message', {
                currentStore: 'STORE1',
                currentScreen: OfflineActiveScreen.SizeSelect,
                justUpdateGuidelines: true,
                guidelinesData: newDrawGuidelinesData,
              });
            }
          }
        },
        isEnabled: nextMeasDict?.[itemKey + "Plus"]?.isServiceable && !followingClothingBodyMeas.includes(chosenBodyMeasKey),
        needsMod: nextMeasDict?.[itemKey + "Plus"]?.needsMod,
      }
    };

    inputClothMeasActionsDict[itemKey] = itemObject;
  }

  const drawGuidelinesDataUsed = forceGuidelinesData ? forceGuidelinesData : drawGuidelinesData;

  let children: JSX.Element[] = [];
  let submitChildren: JSX.Element[] = [];

  children.push(
    <OverlayComponentBaseContainerHorizontal>
      <OverlayComponentBaseContainerWidth
        widthMdUp="100%"
        widthSmDown="100%">
        <Grid container>
          {
            isMdOrUp && isStoreScreen ? 
            <Grid item xs={12}>
              <Box style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '20px 30px', borderRadius: '30px', boxShadow: '0px 2.5px 10px rgba(0, 0, 0, 0.1)', margin: '10px 0px 24px'}}>
                <Box style={{display: 'flex', alignItems: 'center'}}>
                {
                  firstName ?
                  <Box style={{display: 'flex', alignItems: 'center', marginRight: '24px'}}>
                    <Box style={{width: '46px', marginRight: '4px'}}>
                      <UkuranBadanCardMini nama={firstName} width={'46px'} fontSize={'8px'} />
                    </Box>
                    {/* <Typography style={{fontSize: '20px', fontWeight: 600}}>{firstName}</Typography> */}
                  </Box>
                  : null
                }
                {/* <Box style={{height: '41px', width: '26px', borderRight: '1px solid #c9c9c9'}}></Box> */}
                <Box>
                  <Typography style={{fontSize: '10px', color: '#787878', letterSpacing: '0.5px'}}>SEDANG MENGUKUR</Typography>
                  <Typography style={{fontSize: '18px', fontWeight: 500}}>{drawGuidelinesDataUsed?.lastChangedMeasurementName ?? "Lingkar Leher Baju"}</Typography>
                </Box>
                </Box>
                <Box style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', margin: '0px 10px', textAlign: 'center', width: '200px'}}>
                  {/* <Typography style={{fontSize: '10px', color: '#787878'}}>Uk {subtextDictBody?.[(drawGuidelinesDataUsed?.lastChangedMeasurement as ClothingMeasurementsKey) ?? ClothingMeasurementsKey.lingkarLeherBaju]}</Typography> */}
                  <Box style={{width: '60px', scale: '1.6'}}>
                    <SizeWheelComponent  
                      sizeNamesArray={sizeRulerDictBody?.[drawGuidelinesDataUsed?.lastChangedMeasurement as ClothingMeasurementsKey ?? ClothingMeasurementsKey.lingkarLeherBaju]?.sizeNamesArray ?? []} 
                      sizeValuesArray={sizeRulerDictBody?.[drawGuidelinesDataUsed?.lastChangedMeasurement as ClothingMeasurementsKey ?? ClothingMeasurementsKey.lingkarLeherBaju]?.sizeValuesArray ?? []} 
                      currentValue={sizeRulerDictBody?.[drawGuidelinesDataUsed?.lastChangedMeasurement as ClothingMeasurementsKey ?? ClothingMeasurementsKey.lingkarLeherBaju]?.currentValue ?? 10} 
                      clothMeasName={sizeRulerDictBody?.[drawGuidelinesDataUsed?.lastChangedMeasurement as ClothingMeasurementsKey ?? ClothingMeasurementsKey.lingkarLeherBaju]?.clothMeasName ?? 'ax'} />
                  </Box>
                  <Box style={{height: '41px', width: '26px', borderRight: '1px solid #c9c9c9'}}></Box>
                  <Typography style={{fontSize: '20px', letterSpacing: '0.5px', paddingTop: '4px'}}>{currentClothingMeas?.[(drawGuidelinesDataUsed?.lastChangedMeasurement as ClothingMeasurementsKey) ?? ClothingMeasurementsKey.lingkarLeherBaju]} cm</Typography>
                </Box>
              </Box>
            </Grid>
            : null
          }
          <Grid item xs={(isMdOrUp && !isMinimized) ? 6 : 12}
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              // paddingBottom: isMdOrUp ? '100px' : undefined
            }}
          >
            <Box className={classes.canvasContainer} style={{height: '100%', width: (isMdOrUp && !isMinimized) ? '40vw' : '90vw'}}>
              <OverlayComponentCanvas
                clothingType={ClothingType.Body}
                fitType={FitType.RegularFit}
                putAtTop={false}
                scaleRatio={0.75}
                incrementTogether={true}
                goalFit={currentClothingMeas}
                drawGuidelinesData={drawGuidelinesDataUsed}
              />
            </Box>
          </Grid>
          <Grid item xs={(isMdOrUp && !isMinimized) ? 6 : 12} style={{
            paddingBottom: '20px',
          }}> 
            <Grid container>
              {
                !isMdOrUp && (
                  <Grid item xs={12} style={{display: "flex", justifyContent: "center", alignItems: "center", marginBottom: '10px'}}>
                    <Button 
                      disabled={!changesDetected}>
                      <Box 
                        onClick={handleReset} 
                        style={{
                          border: '1px solid #717171',
                          borderColor: changesDetected ? 'black' : 'lightgrey',
                          borderRadius: '20px',
                          marginTop: '5px',
                          padding: '4px 13px 4px 13px',
                          color: changesDetected ? 'black' : 'lightgrey',
                          display: "flex", 
                          justifyContent: "center", 
                          alignItems: "center",
                          gap: '10px'
                      }}>
                        <RestoreIcon 
                          style={{
                            fontSize: '20px'
                          }}
                        />
                        <Typography
                            style={{
                              color: changesDetected ? '#262626' : 'lightgrey',
                              cursor: changesDetected ? 'pointer' : 'default',
                              fontSize: '10px',
                              letterSpacing: '0.5px',
                              fontWeight: 600,
                              paddingTop: '4px'
                            }}
                          >
                            KEMBALI KE UKURAN AWAL
                        </Typography>
                      </Box>
                    </Button>
                  </Grid>
                )
              }
              <Grid item xs={12} 
              style={{
                display: isMdOrUp && !isMinimized? 'block' : 'flex',
                justifyContent: isMdOrUp && !isMinimized? 'flex-start' : 'center',
              }}>
                <PersonalFitMeasurementDetailPanel
                  allowEditing={true}
                  currentClothingMeas={currentClothingMeas}
                  currentClothingMeasSubtextDict={subtextDictBody}
                  currentClothingMeasUpdatedDict={GetChangedClothingMeasurementsFromBodyMeasurementsUpdate(changedClothingBodyMeasCur, currentClothingBodyMeas, ClothingType.Body)}
                  currentlyFetchingAvailability={currentlyFetchingAvail}
                  clothMeasActionsDict={inputClothMeasActionsDict}
                  isMinimized={isMinimized}
                  isSizeWheel={true}
                  sizeWheelDict={sizeRulerDictBody}
                  isMdOrUp={isMdOrUp}
                  // reductionMode={true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </OverlayComponentBaseContainerWidth>
    </OverlayComponentBaseContainerHorizontal>
  );
  submitChildren.push(
    <OverlayComponentBaseContainerHorizontal
    alignItems='flex-end' >
      <Box>
        <Button
          onClick={() => {
            const cleanedClothingBodyMeas: BodyMeasurements = {};
            for (let bodyMeasKey of Object.keys(currentClothingBodyMeas)) {
              if (!followingClothingBodyMeas.includes(bodyMeasKey as BodyMeasurementsKey)) {
                cleanedClothingBodyMeas[bodyMeasKey as keyof BodyMeasurements] = currentClothingBodyMeas[bodyMeasKey as keyof BodyMeasurements];
              }
            }

            // GENERATE DICT OF UPDATED VARIABLES
            const changedClothingBodyMeas: BodyMeasurements = {};
            // CHECK SPECIFIC ON AFTER
            for (let bodyMeasKey of Object.keys(cleanedClothingBodyMeas)) {
              // IF THE VALUE IS DIFFERENT, WE ADD TO CHANGED DICT
              if (currentClothingBodyMeas[bodyMeasKey as keyof BodyMeasurements] !== 
                startingClothingBodyMeasurementsCBComplete[bodyMeasKey as keyof BodyMeasurements]) {
                changedClothingBodyMeas[bodyMeasKey as keyof BodyMeasurements] = currentClothingBodyMeas[bodyMeasKey as keyof BodyMeasurements];
              }
            }
            // CHECK SPECIFIC ON BEFORE
            for (let bodyMeasKey of Object.keys(startingClothingBodyMeasurements)) {
              if (!startingClothingBodyMeasurements?.[bodyMeasKey as keyof BodyMeasurements]) {
                continue;
              }
              // IF THE VALUE IS DIFFERENT, WE ADD TO CHANGED DICT
              if (currentClothingBodyMeas[bodyMeasKey as keyof BodyMeasurements] !== 
                startingClothingBodyMeasurementsCBComplete[bodyMeasKey as keyof BodyMeasurements]) {
                changedClothingBodyMeas[bodyMeasKey as keyof BodyMeasurements] = currentClothingBodyMeas[bodyMeasKey as keyof BodyMeasurements];
              }
            }

            // IF CHANGED IS NONE / NULL, WE USE THE PREVIOUS CHANGED
            handleSubmit(cleanedClothingBodyMeas, currentClothingMeas, changedClothingBodyMeas);
          }}
          style={{
            padding: '7px 25px 4.5px 25px',
            borderRadius: '20px',
            fontSize: '10.5px',
            fontWeight: 600,
            color: 'white',
            letterSpacing: '0.75px',
            backgroundColor: 'black',
            margin: '10px 15px 20px 0px'
          }}
        >
          SIMPAN
        </Button>
      </Box>
    </OverlayComponentBaseContainerHorizontal>
  );

  return (
    <OverlayComponentBaseTemplate alignItems="flex-start">
      <Box
        style={isMinimized ?
          {
            width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
          } : {

          }}
      >
        <Box>
          {
            children
          }
        </Box>
      </Box>
      <Box style={{ width: '100%' }}>
        {
          submitChildren
        }
      </Box>
      <PageProductOverlayMeasureInstructions handleAccept={advancedFeatureCallback ? advancedFeatureCallback : undefined} />
    </OverlayComponentBaseTemplate>
  );
}